import {
  MAP_FILL,
  MAP_HEIGHT,
  POLE_EDGE_CLEARANCE,
  MAP_WIDTH,
} from './constants';
import type { Viewport } from './types';

export type Framing = { zoom: number; x: number; y: number };

const GLOBE_FIT_RADIUS = 1.06;
const GLOBE_VIEWPORT_FILL = 0.92;

export const framing = (): Framing => ({ zoom: 0, x: 0, y: 0 });

export function globeFraming(
  viewport: Viewport,
  zoomOut = 1,
  out = framing()
): Framing {
  const minSide = Math.min(viewport.width, viewport.height);
  out.zoom =
    (((minSide / 2) * GLOBE_VIEWPORT_FILL) / GLOBE_FIT_RADIUS) * zoomOut;
  out.x = 0;
  out.y = 0;
  return out;
}

export function worldFraming(viewport: Viewport, out = framing()): Framing {
  const byWidth = (viewport.width * MAP_FILL) / MAP_WIDTH;
  const byHeight = viewport.height / (MAP_HEIGHT + 2 * POLE_EDGE_CLEARANCE);
  out.zoom = Math.min(byWidth, byHeight);
  out.x = 0;
  out.y = viewport.height / 2 / out.zoom - MAP_HEIGHT / 2 - POLE_EDGE_CLEARANCE;
  return out;
}

export function lerpFraming(
  a: Framing,
  b: Framing,
  t: number,
  out = framing()
): Framing {
  out.zoom = a.zoom + (b.zoom - a.zoom) * t;
  out.x = a.x + (b.x - a.x) * t;
  out.y = a.y + (b.y - a.y) * t;
  return out;
}
